import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { IoNotificationsOutline, IoSearch } from "react-icons/io5";
import { MdOutlineCancel } from "react-icons/md";
import './Styles/Reuseable/Topbar.css';
// import { IoNotificationsOutline } from "react-icons/io5";
import { HiOutlineSupport } from "react-icons/hi";


const SearchOption = ({ type, options }) => {
  return (
    <>
      <p className='search-option'>{type}</p>
      <ul>
        <li className='search-type-result'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat sit similique explicabo</li>
        <li className='search-type-result'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat sit similique explicabo</li>
        <li className='search-type-result'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat sit similique explicabo</li>
        <li className='search-type-result'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat sit similique explicabo</li>
      </ul>
      <div style={{ width: '100%', height: '1px', backgroundColor: 'var(--cal-border-color)', marginTop: '16px' }}></div>
    </>
  )
}

export default function Topbar() {
  const location = useLocation();
  const back = useNavigate();
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchWidth, setSearchWidth] = useState('50%');
  const navigateTo = useNavigate();
  const routeToPageName = {
    '/': 'Forms',
    '/forms/list': 'Forms',
    '/forms/folder': 'Folders',
  };

  const getPageName = () => {
    if (location.pathname.startsWith('/create-form/')) return 'Create Form';

    return routeToPageName[location.pathname] || 'Page Not Found';
  };

  const handleSearchCancel = () => {
    setSearchValue('');
  };

  const shouldShowBackIcon = () =>
    location.pathname.startsWith('/create-form/')
  location.pathname.startsWith('/edit-task');

  const pageName = getPageName();
  const showBackIcon = shouldShowBackIcon();

  return (
    <div className="new-top-bar">
      <div style={{ display: 'flex', alignItems: 'center', columnGap: '1rem' }}>
        {showBackIcon && (
          <MdOutlineKeyboardBackspace
            size={22}
            onClick={() => back(-1)}
            style={{ cursor: 'pointer' }}
          />
        )}
        <div className="page-active-title">{pageName}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '80%' }}>
        <div
          className={`top-bar-searchbar ${searchWidth === '90%' ? 'focused' : ''}`}
          style={{ width: searchWidth, height: searchValue ? 'auto' : '3rem' }}
        >
          <IoSearch
            size={20}
            className="search-icon"
          />
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onFocus={() => setSearchWidth('90%')}
            onBlur={() => setSearchWidth('50%')}
            placeholder="Search..."
          />
          {searchValue && (
            <MdOutlineCancel
              size={20}
              onClick={handleSearchCancel}
              className="cancel-icon"
            />
          )}

          {
            searchValue && (
              <div className="search-results">
                <ul className="search-options">
                  <li>Task</li>
                  <li>User</li>
                  <li>Form</li>
                  <li>Events</li>
                  <li>Chat</li>
                  <li>Reimbursment</li>
                  <li>Response</li>
                </ul>
                <p style={{ marginTop: '1rem' }}>Search results for "{searchValue}"</p>

                <SearchOption type="Task" options={[]} />
                <SearchOption type="Events" options={[]} />
                <SearchOption type="Forms" options={[]} />

              </div>
            )
          }
        </div>
        {/* <div style={{ marginLeft: '1rem' }}>
                    <IoNotificationsOutline size={22} color='#8493B2' onClick={() => navigateTo('/notifications')} />
                </div> */}
        {/* <HiOutlineSupport size={24} color='#8493B2' style={{ marginLeft: '16px' }} onClick={() => navigateTo('/help&support')} /> */}
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBI7wUPfjFWKh0SaMx5fkMQ4idwEMc7HOhbA&s"
          alt="Profile"
          className="profile-picture"
          onClick={() => navigateTo('/settings')}
        />
      </div>
    </div>

  );
}
